export default "__VITE_ASSET__ZXVHlBpk__"